module.exports = __webpack_public_path__ + "static/media/07_APOTHEO_LABO_ALLIANCE.0eed0fe9.png";